import * as React from 'react';
import { Header } from './base';
import './faqSection.module.scss';

const QABlock = ({ question, children }) => (
    <div styleName="qa-block">
        <div styleName="question">Q. {question}</div>
        <div styleName="answer">A. {children}</div>
    </div>
);

const Note = () => (
    <>
        <div styleName="note">
            その他のよくある質問は
            <a href="https://likes.she-inc.jp/faq">こちら</a>
            をご覧ください。
        </div>
        <div styleName="splitter" />
        <div styleName="foot-note">
            移行を希望しないという方は
            <a href="https://docs.google.com/forms/d/e/1FAIpQLSc2FCG_k5esNIfsDqLA7c4NsmAGLvfkwsUEEcinHxKnQsWvOw/viewform?usp=sf_link">
                こちらのフォーム
            </a>
            をご記入ください。
        </div>
    </>
);

export const FaqSection = () => (
    <div styleName="section">
        <Header>よくある質問</Header>
        <QABlock question="今まで購入した残りチケットはどうなるの？">
            新プランにご移行頂くか、現在開催予定のオフラインレッスンにてご利用頂くことが出来ます。<br />
            （オフラインレッスンは2019年9月で開講終了となり、その後は新プランに移行となります。）
        </QABlock>
        <QABlock question="移行はお金がかかるの？">
            かかりません。現在のチケットを２枚→１ヶ月分としてそのままお使いいただけます。<br />
            ※ 無料期間終了後は自動で有料プランに移行します。
        </QABlock>
        <QABlock question="チケットがもうない場合は？">
            入会金なしの、月額料金のみで新プランに移行していただけます。
        </QABlock>
        <QABlock question="新プランへの移行時期を選びたい">
            新プランの開始時期は10/31までの間であればいつでも選択可能です。移行手続きの際に、開始日を選んでいただき、その日が毎月の更新日となります。
        </QABlock>
        <QABlock question="最終いつまでに会員移行すれば良い？">
            10/31までに会員移行をお願いします。<br />
            11/1以降は、自動的に新プランに移行されます。
        </QABlock>
        <QABlock question="もし期限内に移行できなかったらどうなるの？">
            会員移行がされていない場合は2019/11/1以降自動的に新プランに移行されます。
        </QABlock>
        <QABlock question="移行後はどのようにサービスを利用すれば良い？">
            オンラインレッスンは新プランを開始した当日から全て受講いただけます。もくもく会・特別イベントのご予約も同様に全てご利用頂けます。コーチングに関しては、月に１度予約ができますので、ご都合の良い日程でご予約をお願いします。
        </QABlock>
        <QABlock question="無料期間分(残チケット所持枚数分)が終了したらどうなるの？">
            無料期間終了日の翌日から月額課金が始まり、毎月その日に課金される仕組みです。<br />
            例：1日から課金が始まる場合、その後も毎月1日に課金される仕組みです。<br />
            ※引き落とし日はご利用のクレジットカード会社により異なります。
        </QABlock>
        <QABlock question="新プランに移行したくない場合は？">
            1on1カウンセリングを行わせて頂きますので、
            <a
                href="https://docs.google.com/forms/d/e/1FAIpQLSc2FCG_k5esNIfsDqLA7c4NsmAGLvfkwsUEEcinHxKnQsWvOw/viewform?usp=sf_link"
                target="_blank"
            >
                こちらのフォーム
            </a>
            よりアンケートにお答え下さい。
        </QABlock>
        <QABlock question="SHEに通う旧プランの良さである、「仲間との交流」や「直接教えてもらうこと」が無くなってしまうのではと不安。">
            ご安心ください。<br />
            実はこれまで以上に、交流・質問をできる場所を手厚くご用意させて頂いております。<br />
            オンラインコミュニティの中ではいつでも仲間や講師と交流できますし、週3回程はコーチングやもくもく会、特別レッスンなど直接参加できる場所をご用意させて頂いております。
        </QABlock>
        <Note />
    </div>
);
